<div class="slider" [class.slider--disabled]="disabled()">
  <div class="slider__track" #sliderTrack
       (mousedown)="onSliderMouseDown($event)"
       (touchstart)="onSliderTouchStart($event)">
    <div class="slider__bg">
      <div class="slider__bg-left"></div>
      <div class="slider__bg-right"></div>
    </div>
    <div class="slider__fill-wrap">
      <div class="slider__fill-bg"></div>
      <div class="slider__fill-icon"></div>
      <div class="slider__fill"
           [style.width.%]="getFillWidth()"
           [style.left.%]="getFillPosition()">
      </div>
    </div>
  </div>
  <div class="slider__backdrop"></div>
</div>
